module.exports = __webpack_public_path__ + "img/ic_download_sen.74b87a64.svg";